// Syntax highlighting for rich-content code blocks (BBCode [CODE=lang] import
// and the TinyMCE codesample plugin, both rendered as <pre class="language-X">).
//
// Prism is loaded lazily from CDN only on pages that actually contain a code
// block; its autoloader then fetches whatever language grammars are needed
// (yaml, json, toml, properties, java, …) on demand. Highlighting is driven
// manually so it also covers <pre class="language-X"> without an inner <code>.

const PRISM_BASE = 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0'

let prismReady = null

function loadScript(src) {
    return new Promise((resolve) => {
        const s = document.createElement('script')
        s.src = src
        s.onload = resolve
        s.onerror = resolve
        document.head.appendChild(s)
    })
}

function loadPrism() {
    if (window.Prism && window.Prism.highlightElement) {
        return Promise.resolve()
    }
    if (prismReady) {
        return prismReady
    }
    prismReady = new Promise((resolve) => {
        const theme = document.createElement('link')
        theme.rel = 'stylesheet'
        theme.href = `${PRISM_BASE}/themes/prism-tomorrow.min.css`
        document.head.appendChild(theme)

        // Tell Prism not to auto-run on load — we highlight explicitly so that
        // bare <pre class="language-X"> (no <code>) is covered too.
        window.Prism = window.Prism || {}
        window.Prism.manual = true

        loadScript(`${PRISM_BASE}/components/prism-core.min.js`)
            .then(() => loadScript(`${PRISM_BASE}/plugins/autoloader/prism-autoloader.min.js`))
            .then(() => {
                if (window.Prism.plugins && window.Prism.plugins.autoloader) {
                    window.Prism.plugins.autoloader.languages_path = `${PRISM_BASE}/components/`
                }
                resolve()
            })
    })
    return prismReady
}

function highlight() {
    // One selector covers every rich-content container now that the changelog
    // uses .pe-prose.pe-prose-compact instead of its own .changelog-content.
    const blocks = document.querySelectorAll(
        '.pe-prose pre[class*="language-"], .pe-prose code[class*="language-"]'
    )
    if (!blocks.length) {
        return
    }
    loadPrism().then(() => {
        blocks.forEach((el) => {
            try {
                window.Prism.highlightElement(el)
            } catch (e) {
                /* autoloader fetches the grammar async and re-highlights */
            }
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlight)
} else {
    highlight()
}
// Re-run after Livewire SPA navigations (wire:navigate).
document.addEventListener('livewire:navigated', highlight)
